import React from "react";

import "./styles.css";

/**
 * @function NoRecentTransactionsWidget
 * @return {React.Component}
 * @exported true
 * @description This is shown in RecentTransactionsPage when there's no recent transactions.
 */
export default function NoRecentTransactionsWidget(props) {
  return (
    <div className="no-recent-transactions-widget text-center flex-container">
      <div className="content-container flex-height">
        <p className="grey-label">You have no recent transactions.</p>
        <p className="grey-label">Click “View All” for older transactions.</p>
      </div>

    </div>
  )
}
